import React, { Component } from 'react';
import UserSettingsStore from 'Stores/userSettingsStore';
import 'Styles/userSettings/userSettings.scss';
import { observer } from 'mobx-react';
import LoadView from 'Components/Common/loadView';
import queryString from 'query-string';
import { Link, Navigate } from 'react-router-dom';
import { GetDateFromString } from "Utils/CommonFunctions";
import { ShowModal, ShowAlert } from "Utils/CommonFunctions";
import EdsDisclaimerModal from "Components/UserSettings/edsDisclaimerModal";
import RubricsModal from "Components/UserSettings/rubricsModal";
import BlockWindow from "Components/Common/blockWindow";
import RadioButtonList from "Components/Common/RadioButtonList";
import AppStore from 'Stores/AppStore';
import ProductMode from "Utils/ProductMode";
import { Buffer } from 'buffer';
import TransitionBlocker from 'Components/Common/TransitionBlocker';
import SettingsBlock from 'Components/Common/Settings/SettingsBlock';
import NumericSetting from 'Components/Common/Settings/NumericSetting';
import UserSwitcherSetting from 'Components/UserSettings/UserSwitcherSetting';
import ActionSetting from 'Components/Common/Settings/ActionSetting';
import ComboBoxSetting from 'Components/Common/Settings/ComboBoxSetting';
import TextInputSetting from 'Components/Common/Settings/TextInputSetting';
import TextSetting from 'Components/Common/Settings/TextSetting';
import DescriptionTextSetting from 'Components/Common/Settings/DescriptionTextSetting';
import SelectFileSetting from 'Components/Common/Settings/SelectFileSetting';
import AssistentSearchSetting from 'Components/UserSettings/assistentSearchSetting';
import AssistentSetting from 'Components/UserSettings/assistentSetting';
import UserDlSetting from 'Components/UserSettings/userDlSetting';
import DateTimePickerSetting from 'Components/Common/Settings/DateTimePickerSetting';
import HelperDatePickerRange from "Utils/HelperDatePickerRange";
import SettingsBlockItem from 'Components/Common/Settings/SettingsBlockItem';
import SettingsSubBlock from 'Components/Common/Settings/SettingsSubBlock';
import Helper from 'Utils/Helper';

class UserSettings extends Component {
    constructor(props) {
        super(props);

        this.loadText = '';
        this.successText = '';
        this.loaded = 0;
        this.total = 0;
        this.loadedFull = 0;
        this.totalFull = 0;

        /*
         * здесь данные хранятся исключительно во время отображения
         * рубрикатора. Они нужны, чтобы после нажатия "Сохранить" в 
         * нем, данные уползли в общий стейт, а после нажатия "Отменить"
         * сбросились и забылись
         */
        this.selectedRubricId = '';
        this.selectedRubricName = '';
    }

    componentDidMount() {
        AppStore.OnMainComponentMount('Профиль', 'userSettings', this.ReloadData);

        const params = queryString.parse(this.props.location.search);
        UserSettingsStore.userId = params.userId;

        let hashToScroll = window.location.hash;

        location.hash = '';
        location.hash = hashToScroll;

        UserSettingsStore.StartUpdateUserInfo();

        this.ReloadData();
    }

    componentWillUnmount() {
        UserSettingsStore.StopUpdateUserInfo();
        UserSettingsStore.ClearStore();
        UserSettingsStore.UnblockWindow();
        AppStore.meetingSwitcherEnabledCurrentUser = false;
    }

    ReloadData() {
        UserSettingsStore.GetSettings();
    }

    OnRubricChanged(nodeId, nodeName) {
        this.selectedRubricId = nodeId;
        this.selectedRubricName = nodeName;
    }

    ShowRubricsModal() {
        UserSettingsStore.GetRubricsForModal();
        ShowModal({
            header: 'Рубрика',
            canBeClosed: true,
            className: 'RubricsModal',
            children: <RubricsModal onRubricChanged={this.OnRubricChanged.bind(this)} />,
            buttons: [{
                closer: true,
                content: 'Отменить'
            }, {
                closer: true,
                content: 'Сохранить',
                onClick: _ => UserSettingsStore.SaveRubricInfo(this.selectedRubricId, this.selectedRubricName)
            }]
        });
    }

    ShowEdsDisclaimerModal() {
        ShowModal({
            className: 'eds-disclaimer-block',
            header: 'Соглашение о правах и обязанностях',
            canBeClosed: true,
            children: <EdsDisclaimerModal />,
            buttons: [{
                content: 'не согласен',
                closer: true,
                onClick: _ => UserSettingsStore.SetEdsAgreementState(false)
            }, {
                content: 'согласен',
                closer: true,
                onClick: _ => UserSettingsStore.SetEdsAgreementState(true)
            }]
        });
    }

    /**
     * @param {File | null} file 
     */
    async SetEdsArchiveFile(file) {
        if (file) {
            if (file.name.split('.').pop().toLowerCase() !== 'pfx') {
                ShowAlert('error', <span>Неверный формат файла.<br />Пожалуйста, загрузите файл с расширением .pfx.</span>);
                return;
            }

            let maxFileSize = 32 * 1024;
            if (file.size > maxFileSize) {
                ShowAlert('error', 'Слишком большой файл. Не более 32Кб.');
                return;
            }

            UserSettingsStore.edsArchive = Buffer.from(await file.arrayBuffer()).toString('base64');
            UserSettingsStore.SetSettingOfCurrentProductMode("EdsArchiveName", file.name);
        }
        else {
            ShowAlert('warning', 'Вы собираетесь удалить контейнер с электронной подписью пользователя. Удаление произойдёт после того, как профиль пользователя будет сохранён.');
            UserSettingsStore.SetSettingOfCurrentProductMode("EdsArchiveName", null);
        }
    }

    render() {
        if (UserSettingsStore.redirectTo404) {
            return <Navigate to={`${window.SmrLocation}/404`} />;
        }

        if (this.props.migrationNeeded) {
            return (
                <Navigate to={`${window.SmrLocation}/migration`} />
            )
        }
        if (
            UserSettingsStore.userInfo?.isBlockedChangeSettings == true
            ||
            (
                UserSettingsStore.userInfo?.meetingSwitcherEnabledCurrentUser == false
                &&
                AppStore.isMeeting == true
            )
        ) {
            return <Navigate to={`${window.SmrLocation}/users`} />;
        }

        if (AppStore.dmsisIsWork == false && UserSettingsStore.blockWindow == false && UserSettingsStore.settingsAreLoading == false) {
            window.location.reload(); // для запуска блокировки страницы
        }

        let beginWorkText = UserSettingsStore.oldDocumentsLoaded ? "Повторить синхронизацию" : "Начать синхронизацию";

        let cabinetDLsLoaded =
            UserSettingsStore.cabinetDLs != null;
        let cabinetDLsAddButtonVisible =
            cabinetDLsLoaded
            &&
            UserSettingsStore.cabinetDLs.addButtonVisible;
        let cabinetDLsCanAdd =
            cabinetDLsAddButtonVisible
            &&
            UserSettingsStore.settingsAreLoading != true
            &&
            cabinetDLsLoaded
            &&
            UserSettingsStore.cabinetDLs.availableToAdd.length > 0
            &&
            UserSettingsStore.cabinetDLs.existed.length < 3
            ;

        let edsSettingsBlockTitle = UserSettingsStore.dmsisStatus.isSedTitul ? "Электронная цифровая подпись" : 'Электронная подпись';
        let edsShortWordString = UserSettingsStore.dmsisStatus.isSedTitul ? "ЭЦП" : 'ЭП';

        let settingsMaintanceForCheckVisibility = [
            <ActionSetting
                key='update-dictionaries-button'
                id='update-dictionaries-button'
                title='Обновить справочники'
                value='Обновить'
                onClick={_ => UserSettingsStore.UpdateDictionaries()} />
            ,
            <ComboBoxSetting
                key='copySettingsFrom'
                id='copySettingsFrom'
                title='Скопировать настройки пользователя от:'
                values={UserSettingsStore.copySettingsFrom.users}
                selectedItem={UserSettingsStore.copySettingsFrom.selectedUser}
                onSelectedItemChanged={(key) => UserSettingsStore.SetCopySettingsFrom(key)}
                buttonId='copy-settings-button'
                buttonValue='Применить'
                buttonDisabled={UserSettingsStore.copySettingsFrom.selectedUser == null ||
                    UserSettingsStore.copySettingsFrom.selectedUser === 0}
                buttonClick={() => UserSettingsStore.CopySettings()} />
        ];
        let settingsMaintance =
            ProductMode.FilterControls(
                AppStore.productModeSettings?.filterUserMaintanceSettingsWebKeysVisible,
                settingsMaintanceForCheckVisibility
            );

        let settingsOtherForCheckVisibility = [
            <UserSwitcherSetting
                key='isSearchEnabled'
                id='isSearchEnabled'
                title='Поиск документов в СЭД'
                settingName='isSearchEnabled' />
            ,
            <UserSwitcherSetting
                key='protocolEnable'
                id='protocolEnable'
                title='Протоколирование'
                settingName='protocolEnable' />
        ];
        let settingsOther =
            ProductMode.FilterControls(
                AppStore.productModeSettings?.filterUserAdditionalSettingsWebKeysVisible,
                settingsOtherForCheckVisibility
            );

        let settingsTechSupportForCheckVisibility = [
            <ActionSetting
                key='export-button'
                id='export-button'
                title='Экспорт настроек пользователя:'
                value='Экспортировать'
                onClick={() => UserSettingsStore.ExportSettings()} />
            ,
            <TextInputSetting
                key='supportEmail'
                id='supportEmail'
                title='Адрес техподдержки:'
                value={UserSettingsStore.GetSettingOfCurrentProductMode("SupportEmail") ?? ""}
                onChanged={(val) => UserSettingsStore.SetSettingOfCurrentProductMode("SupportEmail", val)}
                invalid={UserSettingsStore[UserSettingsStore.GetPropertyNameOfCurrentProductMode("SupportEmailError")] === true}
                helperText='Если для пользователя не указан персональный e-mail адрес службы технической поддержки, тогда будет использоваться общий e-mail адрес, заданный в разделе "Настройки". При указании нескольких e-mail адресов их следует разделять запятой (,).'
                textOptions={{ multiple: true, maxLength: 50, type: 'email' }} />
        ];
        let settingsTechSupport =
            ProductMode.FilterControls(
                AppStore.productModeSettings?.filterUserTechSupportSettingsWebKeysVisible,
                settingsTechSupportForCheckVisibility
            );

        let settingsForCheckVisibility = [
            <SettingsBlock
                key='userdl-settings-block'
                id='userdl-settings-block'
                title='Используемые должностные лица'
                helperText={AppStore.isMeeting ? null : 'Пользователь может быть ассоциирован не более чем с тремя должностными лицами.'}>
                {
                    cabinetDLsLoaded != true ? null :
                        UserSettingsStore.cabinetDLs.existed.map(dlInfo =>
                            <UserDlSetting
                                key={`userdlinfo-${dlInfo.contactLid}`}
                                canDelete={UserSettingsStore.settingsAreLoading == false}
                                doDelete={() => {
                                    ShowModal({
                                        maxWidth: "800px",
                                        canBeClosed: true,
                                        header: 'Удаление должностного лица',
                                        children: (
                                            <div style={{ textAlign: "center" }}>
                                                Вы собираетесь удалить ассоциированное должностное лицо:<br />
                                                <b>{Helper.StringTruncateToDisplayUserDlTitle(dlInfo.title)}</b><br />
                                                Это безвозвратно удалит все его изменения по документам и связанные с ними файлы.<br />
                                                Вы уверены?
                                            </div>
                                        ),
                                        buttons:
                                            [{
                                                content: 'Нет',
                                                closer: true
                                            },
                                            {
                                                content: 'Да',
                                                className: 'red-button',
                                                closer: true,
                                                onClick: _ => UserSettingsStore.DeleteDl(dlInfo.contactLid)
                                            }]
                                    })
                                }}
                                dlInfo={dlInfo} />
                        )
                }
                {
                    cabinetDLsAddButtonVisible == false ? null :
                        <ActionSetting
                            key='add-userdl-button'
                            id='add-userdl-button'
                            value='Добавить новое должностное лицо'
                            disabled={!cabinetDLsCanAdd}
                            onClick={() => {
                                if (cabinetDLsCanAdd) {
                                    ShowModal({
                                        className: "add-userdl-modal",
                                        canBeClosed: true,
                                        header: 'Добавление должностного лица',
                                        children: (
                                            <RadioButtonList
                                                items={UserSettingsStore.cabinetDLs.availableToAdd}
                                                selectorId={dlInfo => dlInfo.contactLid}
                                                selectorTitle={dlInfo => Helper.StringTruncateToDisplayUserDlTitle(dlInfo.title)}
                                                onItemSelected={contactLid => UserSettingsStore.OnCabinetDLSelected(contactLid)}
                                                getSelectedItemId={() => UserSettingsStore.cabinetDLLidSelectedFirst}
                                            />
                                        ),
                                        buttonsStyleJustifyContent: "right",
                                        onCloseClick: () => UserSettingsStore.OnCabinetDLClearSelectionStore(),
                                        getButtons: () =>
                                            [
                                                {
                                                    content: 'Отменить',
                                                    closer: true,
                                                    onClick: _ => UserSettingsStore.OnCabinetDLClearSelectionStore(),
                                                },
                                                {
                                                    content: 'Добавить',
                                                    className: 'blue-button ' + (UserSettingsStore.cabinetDLsContactLidsToAdd.length > 0 ? "" : "disabled"),
                                                    closer: true,
                                                    onClick: _ => {
                                                        if (UserSettingsStore.cabinetDLsContactLidsToAdd.length > 0) {
                                                            UserSettingsStore.AddDl();
                                                        }
                                                    },
                                                }
                                            ]
                                    });
                                }
                            }} />
                }
            </SettingsBlock>
            ,
            <SettingsBlock
                key='sync-settings-block'
                id='sync-settings-block'
                title='Синхронизация'
                helperText='Для того, чтобы начать работу, необходимо произвести первичную синхронизацию пользователя.'>

                <DateTimePickerSetting
                    key='start-date'
                    id='start-date'
                    title='Синхронизировать РК / РКПД начиная с:'
                    helperText='Как только вы запустите процесс синхронизации данных, изменить дату сможет только пользователь с правами администратора.'
                    pickerOptions={{
                        getRenderStore: () => UserSettingsStore.renderStore.startDate,
                        setRenderStore: val => UserSettingsStore.renderStore.startDate = val,
                        getValue: () => GetDateFromString(UserSettingsStore.settings.receiveDocumentsFrom.value),
                        setValue: (date) => UserSettingsStore.SetSetting('receiveDocumentsFrom', date.toISOString()),
                        timeVisible: false,
                        canClear: false,
                        getMaxDate: () => HelperDatePickerRange.GetMaxDateToExistedValues(),
                        getMinDate: () => new Date('2000-01-01')
                    }}
                    buttonId='begin-work-button'
                    buttonValue={beginWorkText}
                    buttonClick={_ => UserSettingsStore.SaveSettings(true)}
                />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='cb-sync-settings-block'
                id='cb-sync-settings-block'
                title='Синхронизация'
                helperText='Для того, чтобы начать работу, необходимо произвести первичную синхронизацию пользователя.'>

                <ActionSetting
                    key='begin-work-button'
                    id='begin-work-button'
                    value={beginWorkText}
                    onClick={_ => UserSettingsStore.SaveSettings(true)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='meeting-sync-settings-block'
                id='meeting-sync-settings-block'
                title='Синхронизация'
                helperText='Для того, чтобы начать работу, необходимо произвести первичную синхронизацию пользователя.'>

                <ActionSetting
                    key='begin-work-button'
                    id='begin-work-button'
                    title='Синхронизировать совещания на период с сегодняшнего дня по следующие 12 месяцев:'
                    helperText='Совещания со статусом "Голосование", "Опросный лист", "Согласование протокола", "Отменен" будут синхронизированы на период с "сегодня минус 1 месяц" по следующие 12 месяцев.'
                    value={beginWorkText}
                    onClick={_ => UserSettingsStore.SaveSettings(true)} />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='maintance-settings-block'
                id='maintance-settings-block'
                title='Обслуживание'>

                {settingsMaintance}

            </SettingsBlock>
            ,
            <SettingsBlock
                key='files-settings-block'
                id='files-settings-block'
                title='Обработка файлов'>

                <NumericSetting
                    key='maxFileSizeMb'
                    id='maxFileSizeMb'
                    title='Не пересылать файлы больше (Мб)'
                    minValue={0}
                    maxValue={100}
                    value={UserSettingsStore.settings.maxFileSizeMb?.value}
                    valueChanged={(val) => UserSettingsStore.SetSetting('maxFileSizeMb', val)}
                    onResetToDefaultMax={() => ShowAlert('error', `Установлено максимальное значение (Мб).`)}
                />

                <UserSwitcherSetting
                    key='notLoadOperationsFiles'
                    id='notLoadOperationsFiles'
                    title='Не скачивать автоматически файлы для отчетов, виз и подписей'
                    settingName='notLoadOperationsFiles' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='meeting-files-settings-block'
                id='meeting-files-settings-block'
                title='Обработка файлов'>

                <NumericSetting
                    key='meetingMaxFileSizeMb'
                    id='meetingMaxFileSizeMb'
                    title='Не пересылать файлы больше (Мб)'
                    minValue={0}
                    maxValue={100}
                    value={UserSettingsStore.settings.meetingMaxFileSizeMb?.value}
                    valueChanged={(val) => UserSettingsStore.SetSetting('meetingMaxFileSizeMb', val)}
                    onResetToDefaultMax={() => ShowAlert('error', `Установлено максимальное значение (Мб).`)}
                />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='assistent-settings-block'
                id='assistent-settings-block'
                title='Работа с помощником'>

                <AssistentSearchSetting key='search-assistent'>
                    {
                        UserSettingsStore.settings.assistents.value
                            .map(assistent => (
                                <AssistentSetting
                                    key={assistent.userLid}
                                    mainAssistentLid={UserSettingsStore.settings.mainAssistentUserLid.value}
                                    deleteAssistent={_ => UserSettingsStore.DeleteAssistent(assistent.userLid)}
                                    makeMainAssistent={_ => UserSettingsStore.SetMainAssistent(assistent.userLid)}
                                    assistent={assistent} />
                            ))
                    }
                </AssistentSearchSetting>

                <UserSwitcherSetting
                    key='useAssistentDictionaries'
                    id='useAssistentDictionaries'
                    title='Выгружать списки главного помощника'
                    settingName='useAssistentDictionaries' />

                <UserSwitcherSetting
                    key='gatewayAssistent'
                    id='gatewayAssistent'
                    title='Получать документы на рассмотрение через помощника'
                    settingName='gatewayAssistent' />

                <UserSwitcherSetting
                    key='canImprovement'
                    id='canImprovement'
                    title='Отправлять проект поручения на доработку'
                    settingName='canImprovement' />

                <UserSwitcherSetting
                    key='sendProjectsViaAssistent'
                    id='sendProjectsViaAssistent'
                    title='Рассылать проекты поручений через помощника'
                    settingName='sendProjectsViaAssistent' />

                <UserSwitcherSetting
                    key='canReport'
                    id='canReport'
                    title='Показывать в поручении кнопку "Написать отчет" / "Изменить отчет"'
                    settingName='canReport' />

                <UserSwitcherSetting
                    key='isReportRequired'
                    id='isReportRequired'
                    title='Считать поручение исполненным только после ввода отчета (с датой)'
                    settingName='isReportRequired' />

                <UserSwitcherSetting
                    key='gatewayVisaAssistant'
                    id='gatewayVisaAssistant'
                    title='Получать проекты документов на визирование через помощника'
                    settingName='gatewayVisaAssistant' />

                <UserSwitcherSetting
                    key='gatewaySignAssistant'
                    id='gatewaySignAssistant'
                    title='Получать проекты документов на подпись через помощника'
                    settingName='gatewaySignAssistant' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='cb-assistent-settings-block'
                id='cb-assistent-settings-block'
                title='Работа с помощником'>

                <AssistentSearchSetting
                    key='search-assistent'
                    cbMode={true}>
                    {
                        UserSettingsStore.settings.assistents.value
                            .map(assistent => (
                                <AssistentSetting
                                    key={assistent.userLid}
                                    mainAssistentLid={UserSettingsStore.settings.mainAssistentUserLid.value}
                                    deleteAssistent={_ => UserSettingsStore.DeleteAssistent(assistent.userLid)}
                                    makeMainAssistent={_ => UserSettingsStore.SetMainAssistent(assistent.userLid)}
                                    assistent={assistent}
                                    cbMode={true} />
                            ))
                    }
                </AssistentSearchSetting>

            </SettingsBlock>
            ,
            <SettingsBlock
                key='folders-settings-block'
                id='folders-settings-block'
                title='Папки и подпапки'
                className="SettingsSubBlocks-container"
            >

                <SettingsSubBlock title="Общие папки:">

                    <UserSwitcherSetting
                        key='urgentFolder'
                        id='urgentFolder'
                        title='"Срочные"'
                        settingName='urgentFolder' />

                    <UserSwitcherSetting
                        key='addUrgentProjectsToUrgentFolder'
                        id='addUrgentProjectsToUrgentFolder'
                        title='Добавлять срочные проекты документов'
                        helperText='В папке "Срочные" будут отображаться проекты документов, направленные пользователю на визирование или на подпись, а также имеющие срок меньше либо равный 24 часам.'
                        settingName='addUrgentProjectsToUrgentFolder'
                        className="setting-level-2"
                    />

                    <UserSwitcherSetting
                        key='allReceivedFolder'
                        id='allReceivedFolder'
                        title='"Все поступившие"'
                        settingName='allReceivedFolder' />

                    <UserSwitcherSetting
                        key='inWorkFolder'
                        id='inWorkFolder'
                        title='"В работе"'
                        settingName='inWorkFolder' />

                    <UserSwitcherSetting
                        key='newFolder'
                        id='newFolder'
                        title='"Новые"'
                        helperText='По умолчанию в папке "Новые" отображаются только документы.'
                        settingName='newFolder' />

                    <UserSwitcherSetting
                        key='newFolderProjects'
                        id='newFolderProjects'
                        title='Добавлять новые проекты документов'
                        helperText='В папку "Новые" будут добавлены проекты документов.'
                        settingName='newFolderProjects'
                        className="setting-level-2"
                    />

                    <UserSwitcherSetting
                        key='userFolders'
                        id='userFolders'
                        title='Избранное'
                        helperText='Личные папки'
                        settingName='userFolders' />

                    <ComboBoxSetting
                        key='keep-history-period-listbox'
                        id='keep-history-period-listbox'
                        title='Хранить историю просмотров за:'
                        values={UserSettingsStore.historyLifetime}
                        selectedItem={UserSettingsStore.settings.historyInterval.value}
                        onSelectedItemChanged={(key) => UserSettingsStore.SetSetting('historyInterval', key)} />

                </SettingsSubBlock>

                <SettingsSubBlock title="Папки документов:">

                    <UserSwitcherSetting
                        key='underConsiderationFolder'
                        id='underConsiderationFolder'
                        title='"На рассмотрение"'
                        settingName='underConsiderationFolder' />

                    <UserSwitcherSetting
                        key='notReceiveForForwarding'
                        id='notReceiveForForwarding'
                        title='Не получать документы по пересылке'
                        settingName='notReceiveForForwarding'
                        className="setting-level-2"
                    />

                    <UserSwitcherSetting
                        key='resolutionProjectFolder'
                        id='resolutionProjectFolder'
                        title='"Проекты поручений"'
                        settingName='resolutionProjectFolder'
                        className="setting-level-2"
                    />

                    <UserSwitcherSetting
                        key='resolutionFolder'
                        id='resolutionFolder'
                        title='"Поручения"'
                        settingName='resolutionFolder'
                        className="setting-level-2"
                    />

                    <UserSwitcherSetting
                        key='notConsideredFolder'
                        id='notConsideredFolder'
                        title='"Не рассмотрено"'
                        settingName='notConsideredFolder' />

                    <UserSwitcherSetting
                        key='familarizationFolder'
                        id='familarizationFolder'
                        title='"На ознакомление"'
                        settingName='familarizationFolder' />

                </SettingsSubBlock>

                <SettingsSubBlock title="Папки проектов документов:">

                    <UserSwitcherSetting
                        key='visaFolder'
                        id='visaFolder'
                        title='"На визирование"'
                        settingName='visaFolder' />

                    <UserSwitcherSetting
                        key='signFolder'
                        id='signFolder'
                        title='"На подпись"'
                        settingName='signFolder' />

                    {
                        AppStore.productModeSettings?.cbMode ?
                            <UserSwitcherSetting
                                key='projectFolder'
                                id='projectFolder'
                                title='Папка "Проекты документов"'
                                settingName='projectFolder' />
                            : ''
                    }

                </SettingsSubBlock>

                <SettingsSubBlock title="Рубрикация:">

                    <ActionSetting
                        key='change-rubric-button'
                        id='change-rubric-button'
                        title='Рубрика'
                        value='Изменить'
                        onClick={this.ShowRubricsModal.bind(this)} />

                    <TextSetting
                        key='rootRubricName'
                        id='rootRubricName'
                        title='Выбранная рубрика:'
                        value={(UserSettingsStore.settings.rootRubricName.value === '' || UserSettingsStore.settings.rootRubricName.value == null) ? 'Не выбрана' : UserSettingsStore.settings.rootRubricName.value} />

                    <UserSwitcherSetting
                        key='rubricsInResolutionFolder'
                        id='rubricsInResolutionFolder'
                        title='Использовать рубрики для папки "На рассмотрение"'
                        settingName='rubricsInResolutionFolder' />

                    <UserSwitcherSetting
                        key='rubricsInVisaFolder'
                        id='rubricsInVisaFolder'
                        title='Использовать рубрики для папки "На визирование"'
                        settingName='rubricsInVisaFolder' />

                    <UserSwitcherSetting
                        key='rubricsInSignFolder'
                        id='rubricsInSignFolder'
                        title='Использовать рубрики для папки "На подпись"'
                        settingName='rubricsInSignFolder' />

                </SettingsSubBlock>

            </SettingsBlock>
            ,
            <SettingsBlock
                key='meeting-folders-settings-block'
                id='meeting-folders-settings-block'
                title='Отображение папок и подпапок'>

                <UserSwitcherSetting
                    key='meetingHistoryFolder'
                    id='meetingHistoryFolder'
                    title='Папка "История"'
                    settingName='meetingHistoryFolder' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='control-settings-block'
                id='control-settings-block'
                title='Папки Контроля'>

                <UserSwitcherSetting
                    key='controlFolder'
                    id='controlFolder'
                    title='"На контроле"'
                    settingName='controlFolder'
                />

                <UserSwitcherSetting
                    key='superiorControlFolder'
                    id='superiorControlFolder'
                    title='"Вышестоящий контроль"'
                    settingName='superiorControlFolder'
                    className="setting-level-2"
                />

                <UserSwitcherSetting
                    key='personalControlFolder'
                    id='personalControlFolder'
                    title='"Личный контроль"'
                    settingName='personalControlFolder'
                    className="setting-level-2"
                />

                <UserSwitcherSetting
                    key='initiativeControlFolder'
                    id='initiativeControlFolder'
                    title='"Инициативные поручения"'
                    settingName='initiativeControlFolder'
                    className="setting-level-2"
                />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='documents-settings-block'
                id='documents-settings-block'
                title='Документы и проекты документов'>

                <ComboBoxSetting
                    key='mark-as-read-listbox'
                    id='mark-as-read-listbox'
                    title={"Отмечать запись о документе (проекте документа) как\nпрочтённую"}
                    helperText='Через какое время с записи о документе/ проекте документа снимать метку "ЧтК" /  "Новая РК (РКПД)".'
                    values={UserSettingsStore.timeoutSecPresets}
                    selectedItem={UserSettingsStore.settings.markAsReadTimeoutSec.value}
                    onSelectedItemChanged={(key) => UserSettingsStore.SetSetting('markAsReadTimeoutSec', key)} />

                <UserSwitcherSetting
                    key='canSaveFiles'
                    id='canSaveFiles'
                    title='Разрешить экспорт файлов'
                    settingName='canSaveFiles' />

                <UserSwitcherSetting
                    key='doNotShowPartlyHandledDocuments'
                    id='doNotShowPartlyHandledDocuments'
                    title='Не показывать частично обработанные документы'
                    helperText='Частично обработанные документы будут скрыты из папок пользователя.'
                    settingName='doNotShowPartlyHandledDocuments' />

                <UserSwitcherSetting
                    key='coordinateProjectsWithoutDialogWindow'
                    id='coordinateProjectsWithoutDialogWindow'
                    title='Согласовывать проект документа без диалогового окна'
                    settingName='coordinateProjectsWithoutDialogWindow' />

                <UserSwitcherSetting
                    key='approveProjectsWithoutDialogWindow'
                    id='approveProjectsWithoutDialogWindow'
                    title='Утверждать проект документа без диалогового окна'
                    settingName='approveProjectsWithoutDialogWindow' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='resolution-settings-block'
                id='resolution-settings-block'
                title='Поручение и проект поручения'>

                <ComboBoxSetting
                    key='initiative-listbox'
                    id='initiative-listbox'
                    title='Группа для создания инициативных поручений'
                    values={UserSettingsStore.initiativeGroupList}
                    selectedItem={UserSettingsStore.settings.initiativeResolutionGroupLid.value}
                    onSelectedItemChanged={(key) => UserSettingsStore.SetSetting('initiativeResolutionGroupLid', key)}
                    emptyPlaceholder='Доступных групп нет' />

                <UserSwitcherSetting
                    key='copyResolutionTextToDocDesc'
                    id='copyResolutionTextToDocDesc'
                    title='Копировать текст инициативного поручения в поле "Содержание" документа'
                    settingName='copyResolutionTextToDocDesc' />

                <UserSwitcherSetting
                    key='copyTextFromParentRes'
                    id='copyTextFromParentRes'
                    title='Копировать текст из родительского поручения в подчиненное поручение'
                    settingName='copyTextFromParentRes' />

                <UserSwitcherSetting
                    key='canAddInfExecutors'
                    id='canAddInfExecutors'
                    title='Показывать блок "Для ознакомления" в проекте поручения, чтобы назначить исполнителей категории для ознакомления'
                    settingName='canAddInfExecutors' />

                <UserSwitcherSetting
                    key='canAddSeveralRespExecutors'
                    id='canAddSeveralRespExecutors'
                    title='Разрешить назначение нескольких ответственных исполнителей'
                    settingName='canAddSeveralRespExecutors' />

                <UserSwitcherSetting
                    key='respExecutorRequired'
                    id='respExecutorRequired'
                    title='Требовать назначения хотя бы одного ответственного исполнителя'
                    settingName='respExecutorRequired' />

                <UserSwitcherSetting
                    key='selectIntermediateDate'
                    id='selectIntermediateDate'
                    title='Разрешить установку промежуточного срока исполнения поручения'
                    settingName='selectIntermediateDate' />

                <UserSwitcherSetting
                    key='copyIntermediateDateFromParentRes'
                    id='copyIntermediateDateFromParentRes'
                    title='Копировать плановый и промежуточный срок исполнения из родительского поручения в подчиненное поручение'
                    settingName='copyIntermediateDateFromParentRes' />

                <UserSwitcherSetting
                    key='alwaysExecuteResolution'
                    id='alwaysExecuteResolution'
                    title='Исполнять вышестоящее поручение (в том числе контрольное) при вводе подчинённого поручения'
                    settingName='alwaysExecuteResolution' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='eds-settings-block'
                id='eds-settings-block'
                title={edsSettingsBlockTitle}>

                <UserSwitcherSetting
                    key='useSimpleEDS'
                    id='useSimpleEDS'
                    title='Использовать простую электронную подпись'
                    helperText='Функция поддерживается СЭД "ДЕЛО" версии 25.3 и новее. Если параметр включен, подпись будет ставиться с помощью ПЭП, даже если есть возможность использовать УКЭП'
                    settingName='useSimpleEDS' />

                <UserSwitcherSetting
                    key='canEdsResolution'
                    id='canEdsResolution'
                    title='На рассмотрение'
                    settingName='canEdsResolution' />

                <UserSwitcherSetting
                    key='canEdsInitiative'
                    id='canEdsInitiative'
                    title='Инициативное поручение'
                    settingName='canEdsInitiative' />

                <UserSwitcherSetting
                    key='requireEdsOnResolution'
                    id='requireEdsOnResolution'
                    title={`Требовать ${edsShortWordString} при подписании поручения`}
                    settingName='requireEdsOnResolution' />

                <UserSwitcherSetting
                    key='canEdsVisa'
                    id='canEdsVisa'
                    title='На визирование'
                    settingName='canEdsVisa' />

                <UserSwitcherSetting
                    key='requireEdsOnVisa'
                    id='requireEdsOnVisa'
                    title={`Требовать ${edsShortWordString} при визировании`}
                    settingName='requireEdsOnVisa' />

                <UserSwitcherSetting
                    key='canEdsSign'
                    id='canEdsSign'
                    title='На подпись'
                    settingName='canEdsSign' />

                <UserSwitcherSetting
                    key='requireEdsOnSign'
                    id='requireEdsOnSign'
                    title={`Требовать ${edsShortWordString} при подписании`}
                    settingName='requireEdsOnSign' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='meeting-eds-settings-block'
                id='meeting-eds-settings-block'
                title='Электронная подпись'>

                <UserSwitcherSetting
                    key='meetingEdsEnabled'
                    id='meetingEdsEnabled'
                    title='Использовать электронную подпись'
                    settingName='meetingEdsEnabled' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='send-eds-settings-block'
                id='send-eds-settings-block'
                title='Передача сертификата и ключа, лицензии'
                helperText={AppStore.isMeeting ? 'Может быть использован только для приложения "ЭОС Совещания" (Android) для передачи сертификатов и ключей электронной подписи, лицензии КриптоПро' : ''}>

                <DescriptionTextSetting
                    key='send-eds-disclaimer-block'
                    text='Для изменения настроек в этом блоке необходимо принять соглашение о правах и обязанностях'
                    isTitle={true} />

                <ActionSetting
                    key='show-disclaimer-button'
                    id='show-disclaimer-button'
                    value='Соглашение о правах и обязанностях'
                    onClick={this.ShowEdsDisclaimerModal.bind(this)} />

                <SelectFileSetting
                    key='certificate_upload'
                    id='certificate_upload'
                    className={`certificate-upload ${UserSettingsStore.acceptedEdsAgreement === true ? '' : 'disabled'}`}
                    title='Сертификат ЭП (.pfx файл)'
                    helperText="Не более 32Кб"
                    accept='.pfx'
                    selectedFileName={UserSettingsStore.GetSettingOfCurrentProductMode("EdsArchiveName")}
                    selectionTitle='Загрузить PFX'
                    onFileSelected={(file) => this.SetEdsArchiveFile(file)} />

                <UserSwitcherSetting
                    key='EdsArchiveAutoUpload'
                    id='EdsArchiveAutoUpload'
                    className={UserSettingsStore.acceptedEdsAgreement === true ? '' : 'disabled'}
                    title='Загрузить сертификат при синхронизации'
                    getSettingName={() => UserSettingsStore.GetSettingNameOfCurrentProductMode("EdsArchiveAutoUpload")} />

                <SettingsBlockItem
                    className='expired-cert-block'
                    key='expired-cert-block'>
                    <div className='expired-cert-block-item'>
                        <div className='expired-cert-block-title'>
                            Используемые сертификаты ЭП:
                        </div>

                        <SettingsBlock
                            key='expired-cert-block'
                            title={(
                                <div className='expired-cert-block-grid'>
                                    <div>Код устройства</div>
                                    <div>Наименование сертификата</div>
                                    <div>Срок действия сертификата</div>
                                </div>
                            )}>
                            {UserSettingsStore.deviceCertificates.length > 0
                                ? UserSettingsStore.deviceCertificates.map(cert => {
                                    return (
                                        <SettingsBlockItem
                                            className={'expired-cert-block-grid' + (cert.isExpired ? ' expired-cert-block-grid-isexpired' : '')}
                                            key={cert.deviceCode} >
                                            <div>{cert.deviceCode}</div>
                                            <div>{cert.certificateName}</div>
                                            <div>{Helper.ToUserFrendlyDateOnlyString(cert.certificateExpirationDate)}</div>
                                        </SettingsBlockItem>
                                    )
                                })
                                : <DescriptionTextSetting
                                    key='expired-cert-empty'
                                    text='ЗАПИСИ ОТСУТСТВУЮТ' />}
                        </SettingsBlock>

                    </div>
                </SettingsBlockItem>

                <TextInputSetting
                    key='CryptoProLicenseKey'
                    id='CryptoProLicenseKey'
                    className={UserSettingsStore.acceptedEdsAgreement === true ? '' : 'disabled'}
                    title='Лицензия КриптоПро:'
                    helperText='Лицензия может быть передана только для приложения EOSmobile (IOS, Android и Аврора)'
                    value={UserSettingsStore.GetSettingOfCurrentProductMode("CryptoProLicenseKey")}
                    onChanged={(val) => UserSettingsStore.SetSettingOfCurrentProductMode("CryptoProLicenseKey", val)} />

                <UserSwitcherSetting
                    key='CryptoProLicenseKeyAutoUpload'
                    id='CryptoProLicenseKeyAutoUpload'
                    className={UserSettingsStore.acceptedEdsAgreement === true ? '' : 'disabled'}
                    title='Загрузить лицензию при синхронизации'
                    getSettingName={() => UserSettingsStore.GetSettingNameOfCurrentProductMode("CryptoProLicenseKeyAutoUpload")} />

                <SettingsBlockItem
                    className='expired-license-block'
                    key='expired-license-block'>
                    <div className='expired-license-block-item'>
                        <div className='expired-license-block-title'>
                            Используемые лицензии КриптоПро:
                        </div>

                        <SettingsBlock
                            key='expired-license-block'
                            title={(
                                <div className='expired-license-block-grid'>
                                    <div>Код устройства</div>
                                    <div>Срок действия лицензии</div>
                                </div>
                            )}>
                            {UserSettingsStore.deviceLicenses.length > 0
                                ? UserSettingsStore.deviceLicenses.map(license => {
                                    return (
                                        <SettingsBlockItem
                                            className={'expired-license-block-grid' + (license.isExpired ? ' expired-license-block-grid-isexpired' : '')}
                                            key={license.deviceCode} >
                                            <div>{license.deviceCode}</div>
                                            <div>{license.licensePermanent ? 'Постоянная' : Helper.ToUserFrendlyDateOnlyString(license.licenseExpirationDate)}</div>
                                        </SettingsBlockItem>
                                    )
                                })
                                : <DescriptionTextSetting
                                    key='expired-license-empty'
                                    text='ЗАПИСИ ОТСУТСТВУЮТ' />}
                        </SettingsBlock>

                    </div>
                </SettingsBlockItem>

            </SettingsBlock>
            ,
            <SettingsBlock
                key='annotation-settings-block'
                id='annotation-settings-block'
                title='Аннотирование файлов'>

                <UserSwitcherSetting
                    key='canAnnotate'
                    id='canAnnotate'
                    title='Аннотирование файлов документов'
                    settingName='canAnnotate' />

                <UserSwitcherSetting
                    key='canAnnotateForVisa'
                    id='canAnnotateForVisa'
                    title='Аннотирование файлов проектов документов, поступивших на визирование'
                    settingName='canAnnotateForVisa' />

                <UserSwitcherSetting
                    key='canAnnotateForSign'
                    id='canAnnotateForSign'
                    title='Аннотирование файлов проектов документов, поступивших на подпись'
                    settingName='canAnnotateForSign' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='other-settings-block'
                id='other-settings-block'
                title='Дополнительные параметры'>
                {settingsOther}
            </SettingsBlock>
            ,
            <SettingsBlock
                key='push-settings-block'
                id='push-settings-block'
                title='Push-уведомления'>

                <UserSwitcherSetting
                    key='meetingPushOnNew'
                    id='meetingPushOnNew'
                    title='Создано новое совещание'
                    helperText='Сообщить пользователю о проведении нового совещания.'
                    settingName='meetingPushOnNew' />

                <UserSwitcherSetting
                    key='meetingPushOnStartToday'
                    id='meetingPushOnStartToday'
                    title='Совещание состоится сегодня'
                    helperText='Сообщить пользователю в 7:00 утра, что совещание состоится сегодня.'
                    settingName='meetingPushOnStartToday' />

                <UserSwitcherSetting
                    key='meetingPushOnStartInHour'
                    id='meetingPushOnStartInHour'
                    title='Совещание начнется через 1 час'
                    helperText='Сообщить пользователю, что совещание начнется через 1 час.'
                    settingName='meetingPushOnStartInHour' />

                <UserSwitcherSetting
                    key='meetingPushOnOpenVoting'
                    id='meetingPushOnOpenVoting'
                    title='Совещание открыто для голосования'
                    helperText='Сообщите пользователю, что он может проголосовать на совещании.'
                    settingName='meetingPushOnOpenVoting' />

                <UserSwitcherSetting
                    key='meetingPushOnOpenVoting'
                    id='meetingPushOnEndWithNotVoted'
                    title='Совещание содержит необработанные вопросы'
                    helperText='Сообщите пользователю, что началось голосование на совещании, где есть несколько нерешённых вопросов.'
                    settingName='meetingPushOnEndWithNotVoted' />

            </SettingsBlock>
            ,
            <SettingsBlock
                key='help-settings-block'
                id='help-settings-block'
                title='Техническая поддержка'
                onTitleClick={UserSettingsStore.PickImportSettingsFile.bind(UserSettingsStore)}>
                {settingsTechSupport}
            </SettingsBlock>
            ,
            <SettingsBlock
                key='personalization-settings-block'
                id='personalization-settings-block'
                title='Персонализация'>

                <UserSwitcherSetting
                    key='showRightPanelAfterMoveToNextDoc'
                    id='showRightPanelAfterMoveToNextDoc'
                    title='При переходе к следующему документу отображать область файла'
                    helperText='При автоматическом переходе к следующему документу показывать его в режиме «Область файла» с правой панелью в альбомной ориентации. В портретном режиме отображать только «Область файла».'
                    settingName='showRightPanelAfterMoveToNextDoc' />

                <UserSwitcherSetting
                    key='onFolderOpenShowOnlyDocument'
                    id='onFolderOpenShowOnlyDocument'
                    title='При открытии папки или документа через Cover Flow открывать его в режиме без панелей'
                    helperText='При открытии документа отображается только область с файлом.'
                    settingName='onFolderOpenShowOnlyDocument' />

                <UserSwitcherSetting
                    key='blackoutFileInPortrait'
                    id='blackoutFileInPortrait'
                    title='Затемнять область файла в портретном режиме'
                    settingName='blackoutFileInPortrait' />

            </SettingsBlock>
        ];

        let settings = ProductMode.FilterControlsParamsObject({
            webKeysVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysVisible,
            webKeysNotVisible: AppStore.productModeSettings?.filterUserSettingsWebKeysNotVisible,
            controlsForFiltering: settingsForCheckVisibility,
            funcTransformSelect: (control, key) => (
                <SettingsBlock
                    {...control.props}
                    key={key}></SettingsBlock>
            ),
            funcSelectControlKey: (control) => control.props.id
        });

        return (
            <div className='UserSettings'>
                <TransitionBlocker
                    blocked={UserSettingsStore.settingsChanged()}
                />
                <div className='all-settings-container overflowing-element'>
                    <div className='settings-container'>
                        {settings}
                    </div>
                </div>
                <div className="buttons-container">
                    <Link to='../users'>
                        <button>Отменить</button>
                    </Link>
                    <button className={`blue-button`}
                        onClick={_ => UserSettingsStore.SaveSettings()}>
                        Сохранить
                    </button>
                </div>
                {UserSettingsStore.settingsAreLoading ? <LoadView modal={true} /> : ''}
                {UserSettingsStore.blockWindow ? <BlockWindow /> : ''}
            </div>
        )
    }
}

export default observer(UserSettings);